module.exports = __webpack_public_path__ + "img/if.be5030ca.webp";